// Central site + asset configuration.
// All DealAlert assets are REAL (delivered by client). Other projects use
// neutral placeholder frames until their assets arrive ("Asset benötigt").

export const COMPANY = {
  name: "Cloud Service International j.d.o.o.",
  brand: "CloudService",
  domain: "cloudservice.hr",
  email: "info@cloudservice.hr",
  locations: "Wien / Zagreb",
  address: "IX. Bukovački ogranak 3C, Zagreb, Kroatien",
  oib: "83585817969",
  mbs: "081655038",
  vat: "HR83585817969",
  euid: "HRSR.081655038",
  court: "Trgovački sud u Zagrebu",
  founder: "Josip Prgomet",
  whatsapp: "", // TODO: WhatsApp number pending from client
  instagram: "https://www.instagram.com/cloudservice.hr",
};

const A = "/assets/dealalert";

export const DEALALERT_ASSETS = {
  logo: `${A}/dealalert_logo.png`,
  desktop: {
    topdeals: `${A}/dealalert_01_topdeals_desktop.webp`,
    feed: `${A}/dealalert_02_feed_desktop.webp`,
    detailAdvisor: `${A}/dealalert_03_detail_advisor_desktop.webp`,
    shareEarn: `${A}/dealalert_04_share_earn_desktop.webp`,
    referralStats: `${A}/dealalert_05_referral_stats_desktop.webp`,
    yieldAdvisor: `${A}/dealalert_06_yield_advisor_desktop.webp`,
    landing: `${A}/dealalert_07_landing_desktop.webp`,
    categories: `${A}/dealalert_08_categories_desktop.webp`,
    admin: `${A}/dealalert_09_admin_desktop.webp`,
  },
  mobile: {
    swipeFeed: `${A}/dealalert_m01_swipefeed_mobile.webp`,
    detail: `${A}/dealalert_m02_detail_mobile.webp`,
    advisor: `${A}/dealalert_m03_advisor_mobile.webp`,
    advisorRisk: `${A}/dealalert_m04_advisor_risk_mobile.webp`,
    shareEarn: `${A}/dealalert_m07_share_earn_mobile.webp`,
    favorites: `${A}/dealalert_m08_favorites_mobile.webp`,
    topdeals: `${A}/dealalert_m09_topdeals_mobile.webp`,
  },
  video: {
    swipe: `${A}/dealalert_swipe_video.mp4`,
    swipePoster: `${A}/dealalert_swipe_poster.webp`,
  },
};

// ============================================================
// DEALALERT 2 — Flagship Case Study asset mapping (REAL client assets,
// delivered as 2 ZIPs: desktop foto/video + mobile fotos/video).
// All screens are real product screenshots; videos are real screen
// recordings from the iOS app. Optimized to WebP / H.264+VP9.
// Single source of truth — to swap an asset later, change ONLY here.
// w/h = intrinsic sizes (prevents lazy-load layout shift).
// ============================================================
export const DA2 = {
  logo: `${A}/dealalert_logo.png`,

  // Hero
  hero: { src: `${A}/da2_hero_desktop.webp`, alt: "DealAlert — Landing: AI findet Auto- und Immobiliendeals", w: 1600, h: 903 },
  heroPhone: { src: `${A}/da2_landing_mobile.webp`, alt: "DealAlert iOS — Landing", w: 860, h: 1861 },

  // Problem — viele Inserate ohne Vergleichbarkeit
  problem: { src: `${A}/da2_feed_desktop.webp`, alt: "DealAlert — DealFeed mit vielen Inseraten", w: 1600, h: 949 },

  // Solution — DealCard versteht das Inserat
  solution: { src: `${A}/da2_morethanlisting_desktop.webp`, alt: "DealAlert — Mehr als ein Inserat: Preis, Daten, Markt-Signal", w: 1600, h: 956 },
  solutionPhone: { src: `${A}/da2_topdeals_mobile.webp`, alt: "DealAlert iOS — Top Deals", w: 860, h: 1861 },

  // Product Flow — Discover / Evaluate / Ask AI / Save & Act
  flow: {
    discover: {
      desktop: { src: `${A}/da2_swipe_desktop.webp`, alt: "DealAlert — Swipe. Check. Save.", w: 1600, h: 902 },
      phoneVideo: {
        src: `${A}/da2_swipe_mobile.mp4`,
        webm: `${A}/da2_swipe_mobile.webm`,
        poster: `${A}/da2_swipe_mobile_poster.webp`,
        alt: "DealAlert iOS — Swipe DealFeed (Screen Recording)",
        w: 720, h: 1558,
      },
    },
    evaluate: {
      desktop: { src: `${A}/da2_compare_desktop.webp`, alt: "DealAlert — Detail & Vergleich: Kontext statt Bauchgefühl", w: 1600, h: 905 },
      phone: { src: `${A}/da2_compare_mobile.webp`, alt: "DealAlert iOS — Vergleich mit ähnlichen Angeboten (konservativ, geringe Datenbasis = kein Signal)", w: 860, h: 1861 },
    },
    askAi: {
      desktop: { src: `${A}/da2_askai_desktop.webp`, alt: "DealAlert — Frag die KI: Orientierung statt Bauchgefühl", w: 1600, h: 904 },
      phone: { src: `${A}/da2_advisor_mobile.webp`, alt: "DealAlert iOS — AI Deal Advisor Chat", w: 860, h: 1861 },
    },
    saveAct: {
      desktop: { src: `${A}/da2_shareearn_desktop.webp`, alt: "DealAlert — Share & Earn Referral", w: 1600, h: 703 },
      phone: { src: `${A}/da2_favorites_mobile.webp`, alt: "DealAlert iOS — Favoriten", w: 860, h: 1861 },
    },
  },

  // System behind — live product flow video + dashboard
  system: {
    video: {
      src: `${A}/da2_flow_desktop.mp4`,
      webm: `${A}/da2_flow_desktop.webm`,
      poster: `${A}/da2_flow_desktop_poster.webp`,
      alt: "DealAlert — Dashboard, Top Deals & Favoriten (Screen Recording)",
      w: 1280, h: 760,
    },
    dashboard: { src: `${A}/da2_topdeals_desktop.webp`, alt: "DealAlert — Top Deals Dashboard: stärkste Signale zuerst", w: 1600, h: 948 },
  },

  // Business value — Subscription / Pricing
  value: {
    pricing: { src: `${A}/da2_pricing_desktop.webp`, alt: "DealAlert — Pricing & Subscription", w: 1346, h: 1282 },
    searchProfile: { src: `${A}/da2_searchprofile_desktop.webp`, alt: "DealAlert — Suchprofil erstellen", w: 1600, h: 905 },
  },
};

// Hero floating devices — centrally swappable
export const HERO_ASSETS = {
  desktop: { src: DEALALERT_ASSETS.desktop.topdeals, alt: "DealAlert — Top Deals Dashboard" },
  phoneFront: { src: DEALALERT_ASSETS.mobile.swipeFeed, alt: "DealAlert iOS — Swipe Feed" },
  phoneBack: { src: DEALALERT_ASSETS.mobile.advisor, alt: "DealAlert iOS — AI Advisor" },
};

// ============================================================
// HAUSDESHANDYS — central asset mapping (all REAL client assets).
// To replace an asset later: change ONLY the path here.
// ============================================================
const H = "/assets/hausdeshandys";

export const HDH_ASSETS = {
  desktop: {
    hero: `${H}/hdh_b1_hero_desktop.webp`,
    pickup: `${H}/hdh_b1_pickup_desktop.webp`,
    brands: `${H}/hdh_b2_brands_desktop.webp`,
    models: `${H}/hdh_b2_models_desktop.webp`,
    options: `${H}/hdh_b3_options_desktop.webp`,
    price: `${H}/hdh_b3_price_desktop.webp`,
    express: `${H}/hdh_b3_express_desktop.webp`,
    checkout: `${H}/hdh_b5_checkout_desktop.webp`,
    services: `${H}/hdh_g_services_desktop.webp`,
    admin: `${H}/hdh_b6_admin_desktop.webp`,
  },
  mobile: {
    hero: `${H}/hdh_b1_hero_mobile.webp`,
    configurator: `${H}/hdh_b2_configurator_mobile.webp`,
    assistant: `${H}/hdh_b4_assistant_mobile.webp`,
    cart: `${H}/hdh_b5_cart_mobile.webp`,
    admin: `${H}/hdh_b6_admin_mobile.webp`,
  },
  video: {
    desktopFlow: `${H}/hdh_flow_desktop.mp4`,
    desktopFlowWebm: `${H}/hdh_flow_desktop.webm`,
    desktopPoster: `${H}/hdh_flow_desktop_poster.webp`,
    mobileFlow: `${H}/hdh_flow_mobile.mp4`,
    mobileFlowWebm: `${H}/hdh_flow_mobile.webm`,
    mobilePoster: `${H}/hdh_flow_mobile_poster.webp`,
  },
};

// Semantic beat mapping for the HausDesHandys story (6 beats).
// w/h = intrinsic sizes (prevents layout shift with lazy loading).
export const HDH_BEAT_ASSETS = {
  // Beat 1 — Premium Shop Experience
  shopHeroDesktop: { src: HDH_ASSETS.desktop.hero, alt: "HausDesHandys — Premium Shop Startseite", w: 1920, h: 1139 },
  shopHeroMobile: { src: HDH_ASSETS.mobile.hero, alt: "HausDesHandys Mobile — Startseite mit Tableiste", w: 880, h: 1657 },
  shopPickup: { src: HDH_ASSETS.desktop.pickup, alt: "HausDesHandys — Abholservice", w: 1920, h: 1142 },
  // Beat 2/3 — Konfigurator-Stepper (Marke → Modell → Reparatur → Preis)
  configuratorSteps: [
    { src: HDH_ASSETS.desktop.brands, alt: "HausDesHandys — Markenauswahl (In 3 Klicks zum Angebot)", w: 1920, h: 1142 },
    { src: HDH_ASSETS.desktop.models, alt: "HausDesHandys — Modellauswahl", w: 1920, h: 1142 },
    { src: HDH_ASSETS.desktop.options, alt: "HausDesHandys — Reparatur-Optionen", w: 1920, h: 1142 },
    { src: HDH_ASSETS.desktop.price, alt: "HausDesHandys — Reparaturpreis sofort", w: 1920, h: 1142 },
  ],
  configuratorMobile: { src: HDH_ASSETS.mobile.configurator, alt: "HausDesHandys Mobile — Schnellreparatur", w: 880, h: 1427 },
  express: { src: HDH_ASSETS.desktop.express, alt: "HausDesHandys — Express-Reparatur in 60 Minuten", w: 1920, h: 1125 },
  // Beat 4 — AI Shopping Assistant
  aiAssistant: { src: HDH_ASSETS.mobile.assistant, alt: "HausDesHandys — AI Shopping Assistant", w: 880, h: 1496 },
  // Beat 5 — Warenkorb & Checkout
  cart: { src: HDH_ASSETS.mobile.cart, alt: "HausDesHandys Mobile — Warenkorb", w: 880, h: 1543 },
  checkout: { src: HDH_ASSETS.desktop.checkout, alt: "HausDesHandys — Checkout & Lieferadresse", w: 1920, h: 1142 },
  // Beat 6 — Admin & Betrieb
  adminDesktop: { src: HDH_ASSETS.desktop.admin, alt: "HausDesHandys — Admin Dashboard", w: 1920, h: 974 },
  adminMobile: { src: HDH_ASSETS.mobile.admin, alt: "HausDesHandys — Admin Dashboard mobil", w: 780, h: 1638 },
  // Motion assets
  flowDesktop: { src: HDH_ASSETS.video.desktopFlow, webm: HDH_ASSETS.video.desktopFlowWebm, poster: HDH_ASSETS.video.desktopPoster, alt: "HausDesHandys — Desktop Flow", w: 1280, h: 762 },
  flowMobile: { src: HDH_ASSETS.video.mobileFlow, webm: HDH_ASSETS.video.mobileFlowWebm, poster: HDH_ASSETS.video.mobilePoster, alt: "HausDesHandys — Mobile Flow", w: 720, h: 1218 },
};

// ============================================================
// NAPERFORMANCE — central asset mapping (all REAL client assets).
// Positioning: AI Performance Advisor (NOT a "chiptuning website").
// NO admin/dashboard visuals — none were delivered, none are faked.
// To replace an asset later: change ONLY the path here.
// ============================================================
const N = "/assets/naperformance";

export const NAP_ASSETS = {
  desktop: {
    hero: `${N}/nap_b1_hero_desktop.webp`,
    ocr: `${N}/nap_b2_ocr_desktop.webp`,
    upload: `${N}/nap_b2_upload_desktop.webp`,
    analysis: `${N}/nap_b4_analysis_desktop.webp`,
  },
  mobile: {
    hero: `${N}/nap_b1_hero_mobile.webp`,
    upload: `${N}/nap_b2_upload_mobile.webp`,
    check: `${N}/nap_b3_check_mobile.webp`,
    analyzing: `${N}/nap_b3_analyzing_mobile.webp`,
    analysis: `${N}/nap_b4_analysis_mobile.webp`,
    stages: `${N}/nap_b5_stages_mobile.webp`,
    advisor: `${N}/nap_b5_advisor_mobile.webp`,
    chat: `${N}/nap_b6_chat_mobile.webp`,
  },
  video: {
    desktopFlow: `${N}/nap_flow_desktop.mp4`,
    desktopFlowWebm: `${N}/nap_flow_desktop.webm`,
    desktopPoster: `${N}/nap_flow_desktop_poster.webp`,
    mobileFlow: `${N}/nap_flow_mobile.mp4`,
    mobileFlowWebm: `${N}/nap_flow_mobile.webm`,
    mobilePoster: `${N}/nap_flow_mobile_poster.webp`,
  },
};

// Semantic beat mapping for the NAPerformance story (7 beats).
// w/h = intrinsic sizes (prevents layout shift with lazy loading).
export const NAP_BEAT_ASSETS = {
  // Beat 1 — Premium Performance Experience
  heroDesktop: { src: NAP_ASSETS.desktop.hero, alt: "NAPerformance — Premium Performance Hero", w: 1920, h: 1027 },
  heroMobile: { src: NAP_ASSETS.mobile.hero, alt: "NAPerformance Mobile — Hero mit Upload-CTA", w: 880, h: 1633 },
  // Beat 2 — OCR Zulassungsschein-Scan (Kerntechnologie)
  ocrDesktop: { src: NAP_ASSETS.desktop.ocr, alt: "NAPerformance — OCR Zulassungsschein-Scan", w: 1920, h: 1027 },
  uploadDesktop: { src: NAP_ASSETS.desktop.upload, alt: "NAPerformance — Upload-Schritt mit gefuehrtem Prozess", w: 1920, h: 1029 },
  // Beats 2–4 — gefuehrter Advisor-Flow (pinned phone sequence)
  advisorFlowSteps: [
    { src: NAP_ASSETS.mobile.upload, alt: "NAPerformance Mobile — Zulassungsschein hochladen", w: 880, h: 1633 },
    { src: NAP_ASSETS.mobile.check, alt: "NAPerformance Mobile — Fahrzeugdaten bestaetigen", w: 880, h: 1633 },
    { src: NAP_ASSETS.mobile.analyzing, alt: "NAPerformance Mobile — KI analysiert das Fahrzeug (Live-Analyse)", w: 880, h: 1633 },
  ],
  // Beat 4 — Analyse & Leistungsvergleich
  analysisDesktop: { src: NAP_ASSETS.desktop.analysis, alt: "NAPerformance — Vorher/Nachher Leistungsvergleich", w: 1920, h: 1030 },
  compareMobile: { src: NAP_ASSETS.mobile.analysis, alt: "NAPerformance Mobile — Leistungsvergleich Serie vs. optimiert", w: 880, h: 1633 },
  // Beat 5 — Stage-Empfehlungen & AI Advisor
  stagesMobile: { src: NAP_ASSETS.mobile.stages, alt: "NAPerformance Mobile — moegliche Optimierungen (Stages)", w: 880, h: 1633 },
  advisorMobile: { src: NAP_ASSETS.mobile.advisor, alt: "NAPerformance Mobile — Empfehlung des KI Advisors mit Angebotsanfrage", w: 880, h: 1633 },
  // Beat 6 — 24/7 KI-Chatberater
  chatMobile: { src: NAP_ASSETS.mobile.chat, alt: "NAPerformance Mobile — 24/7 KI-Chatberater", w: 880, h: 1633 },
  // Beat 7 — Live Flow (Videos)
  flowDesktop: { src: NAP_ASSETS.video.desktopFlow, webm: NAP_ASSETS.video.desktopFlowWebm, poster: NAP_ASSETS.video.desktopPoster, alt: "NAPerformance — Desktop Flow", w: 1280, h: 686 },
  flowMobile: { src: NAP_ASSETS.video.mobileFlow, webm: NAP_ASSETS.video.mobileFlowWebm, poster: NAP_ASSETS.video.mobilePoster, alt: "NAPerformance — Mobile Flow", w: 720, h: 1404 },
};

// ============================================================
// NAAUTOMOBILE — central asset mapping (all REAL client assets).
// Positioning: Premium Autohaus-Plattform mit AI Photo Studio,
// Ankauf-Leadflow, Finanzierung und Haendler-Dashboard.
// NOT "eine Autohaus-Website" — a digital sales + purchase funnel.
// Before/After panels are extracted from the delivered Photo-Studio
// screenshots (real product output; NO fake/stock imagery).
// To replace an asset later: change ONLY the path here.
// ============================================================
const NAA_BASE = "/assets/naautomobile";

export const NAA_ASSETS = {
  desktop: {
    hero: `${NAA_BASE}/naa_b1_hero_desktop.webp`,
    inventory: `${NAA_BASE}/naa_b2_inventory_desktop.webp`,
    detail: `${NAA_BASE}/naa_b2_detail_desktop.webp`,
    financing: `${NAA_BASE}/naa_b4_financing_desktop.webp`,
    sellForm: `${NAA_BASE}/naa_b5_sell_form_desktop.webp`,
    valuation: `${NAA_BASE}/naa_b5_valuation_desktop.webp`,
    dashboard: `${NAA_BASE}/naa_b6_dashboard_desktop.webp`,
    studioCompare: `${NAA_BASE}/naa_b7_studio_compare_desktop.webp`,
    studioResult: `${NAA_BASE}/naa_b7_studio_result_desktop.webp`,
    studioConfig: `${NAA_BASE}/naa_b8_studio_config_desktop.webp`,
    studioShowroom: `${NAA_BASE}/naa_b8_studio_showroom_desktop.webp`,
  },
  mobile: {
    inventory: `${NAA_BASE}/naa_b3_inventory_mobile.webp`,
    financing: `${NAA_BASE}/naa_b4_financing_mobile.webp`,
    sellIntro: `${NAA_BASE}/naa_b5_sell_intro_mobile.webp`,
    valuation: `${NAA_BASE}/naa_b5_valuation_mobile.webp`,
    dashboard: `${NAA_BASE}/naa_b6_dashboard_mobile.webp`,
    dashboard2: `${NAA_BASE}/naa_b6_dashboard2_mobile.webp`,
  },
  beforeAfter: {
    studioBefore: `${NAA_BASE}/naa_ba_studio_before.webp`,
    studioAfter: `${NAA_BASE}/naa_ba_studio_after.webp`,
    showroomBefore: `${NAA_BASE}/naa_ba_showroom_before.webp`,
    showroomAfter: `${NAA_BASE}/naa_ba_showroom_after.webp`,
  },
  video: {
    desktopFlow: `${NAA_BASE}/naa_flow_desktop.mp4`,
    desktopFlowWebm: `${NAA_BASE}/naa_flow_desktop.webm`,
    desktopPoster: `${NAA_BASE}/naa_flow_desktop_poster.webp`,
    mobileFlow: `${NAA_BASE}/naa_flow_mobile.mp4`,
    mobileFlowWebm: `${NAA_BASE}/naa_flow_mobile.webm`,
    mobilePoster: `${NAA_BASE}/naa_flow_mobile_poster.webp`,
  },
};

// Semantic beat mapping for the NAAutomobile story (8 beats + live flow).
export const NAA_BEAT_ASSETS = {
  // Beat 1 — Premium Digital Showroom
  heroDesktop: { src: NAA_ASSETS.desktop.hero, alt: "NAAutomobile — Premium Digital Showroom (Drive your dream)", w: 1920, h: 1098 },
  // Beat 2 — Fahrzeugbestand & Detailseiten
  inventoryDesktop: { src: NAA_ASSETS.desktop.inventory, alt: "NAAutomobile — Fahrzeugbestand mit Filtern", w: 1920, h: 1098 },
  detailDesktop: { src: NAA_ASSETS.desktop.detail, alt: "NAAutomobile — Fahrzeugdetailseite mit Preis, Galerie und CTAs", w: 1920, h: 1098 },
  // Beat 3 — WhatsApp-first Verkauf
  whatsappMobile: { src: NAA_ASSETS.mobile.inventory, alt: "NAAutomobile Mobile — Inventory mit WhatsApp-first Kontakt", w: 880, h: 1633 },
  // Beat 4 — Finanzierungsrechner (unverbindliche Beispielrechnung)
  financingDesktop: { src: NAA_ASSETS.desktop.financing, alt: "NAAutomobile — Finanzierungsrechner mit Anzahlung, Laufzeit und Schlussrate", w: 1920, h: 1098 },
  financingMobile: { src: NAA_ASSETS.mobile.financing, alt: "NAAutomobile Mobile — unverbindliche Beispielrechnung mit Ballonfinanzierung", w: 880, h: 1633 },
  // Beat 5 — Auto verkaufen / unverbindliche KI-Ankaufseinschaetzung
  sellFormDesktop: { src: NAA_ASSETS.desktop.sellForm, alt: "NAAutomobile — Fahrzeug anbieten: Fahrzeugdaten erfassen", w: 1920, h: 1098 },
  valuationDesktop: { src: NAA_ASSETS.desktop.valuation, alt: "NAAutomobile — unverbindliche KI-Vorbewertung mit Preisindikation", w: 1920, h: 1098 },
  sellIntroMobile: { src: NAA_ASSETS.mobile.sellIntro, alt: "NAAutomobile Mobile — NA Automobile kauft Ihr Fahrzeug", w: 880, h: 1633 },
  valuationMobile: { src: NAA_ASSETS.mobile.valuation, alt: "NAAutomobile Mobile — unverbindliche KI-Einschaetzung", w: 880, h: 1633 },
  // Beat 6 — Ankaufanfrage & Leads im Haendler-Dashboard (REAL screens)
  dashboardDesktop: { src: NAA_ASSETS.desktop.dashboard, alt: "NAAutomobile — Haendler-Dashboard mit Inventar und Anfragen", w: 1920, h: 1098 },
  dashboardMobile: { src: NAA_ASSETS.mobile.dashboard, alt: "NAAutomobile Mobile — Dashboard-Uebersicht: Inventar, Ankaufsanfragen, Leads", w: 880, h: 1633 },
  dashboardMobile2: { src: NAA_ASSETS.mobile.dashboard2, alt: "NAAutomobile Mobile — Reservierungen, Probefahrt- und Finanzierungs-Leads", w: 880, h: 1633 },
  // Beat 7 — AI Photo Studio mit View-Lock (Before/After)
  baStudioBefore: { src: NAA_ASSETS.beforeAfter.studioBefore, alt: "Originalfoto — einfaches Fahrzeugfoto", w: 817, h: 544 },
  baStudioAfter: { src: NAA_ASSETS.beforeAfter.studioAfter, alt: "AI Showroom Preview — gleiches Fahrzeug, optimierte Praesentation", w: 818, h: 544 },
  baShowroomBefore: { src: NAA_ASSETS.beforeAfter.showroomBefore, alt: "Originalfoto — Ausgangsbild fuer Showroom-Variante", w: 817, h: 545 },
  baShowroomAfter: { src: NAA_ASSETS.beforeAfter.showroomAfter, alt: "AI Showroom Preview — Showroom-Hintergrund Variante", w: 818, h: 545 },
  studioResultDesktop: { src: NAA_ASSETS.desktop.studioResult, alt: "NAAutomobile — AI Photo Studio mit Vorher/Nachher im Admin", w: 1920, h: 1098 },
  // Beat 8 — AI Background Manager
  studioConfigDesktop: { src: NAA_ASSETS.desktop.studioConfig, alt: "NAAutomobile — Photo Studio: Hintergrund waehlen (Background Manager)", w: 1920, h: 1098 },
  studioShowroomDesktop: { src: NAA_ASSETS.desktop.studioShowroom, alt: "NAAutomobile — Showroom-Hintergrund Variante im Photo Studio", w: 1920, h: 1098 },
  // Live Flow (Videos)
  flowDesktop: { src: NAA_ASSETS.video.desktopFlow, webm: NAA_ASSETS.video.desktopFlowWebm, poster: NAA_ASSETS.video.desktopPoster, alt: "NAAutomobile — Desktop Flow", w: 1280, h: 762 },
  flowMobile: { src: NAA_ASSETS.video.mobileFlow, webm: NAA_ASSETS.video.mobileFlowWebm, poster: NAA_ASSETS.video.mobilePoster, alt: "NAAutomobile — Mobile Flow", w: 720, h: 1404 },
};

// ============================================================
// NOVAPILOT — central asset mapping (all REAL client assets).
// Positioning: Digitaler Autoimport-Assistent mit NoVA-Rule-Engine,
// OCR-Dokumenten, PDF-Protokoll und Lead-Funnel.
// A Fachlogik-Produkt — NOT "eine NoVA-Rechner-Website".
// Legal: keine Steuerberatung, kein offizielles Finanzamt-Tool.
// PDF pages are rendered from the REAL demo Berechnungsprotokoll.
// To replace an asset later: change ONLY the path here.
// ============================================================
const NOVA_BASE = "/assets/novapilot";

export const NOVA_ASSETS = {
  desktop: {
    hero: `${NOVA_BASE}/nova_b1_hero_desktop.webp`,
    fallassistent: `${NOVA_BASE}/nova_b1_fallassistent_desktop.webp`,
    dashboard: `${NOVA_BASE}/nova_b2_dashboard_desktop.webp`,
    wizard: `${NOVA_BASE}/nova_b2_wizard_desktop.webp`,
    upload: `${NOVA_BASE}/nova_b3_upload_desktop.webp`,
    ust: `${NOVA_BASE}/nova_b4_ust_desktop.webp`,
    bewertung: `${NOVA_BASE}/nova_b4_bewertung_desktop.webp`,
    pro: `${NOVA_BASE}/nova_b6_pro_desktop.webp`,
    // Rechtsgrundlagen-Admin-Screen (Regelversionen + Gültigkeitszeiträume) — used in Beat 4 (Rule Engine)
    historie: `${NOVA_BASE}/nova_b6_historie_desktop.webp`,
    // Reserve (delivered, currently unused in layout):
    kostencheck: `${NOVA_BASE}/nova_x_kostencheck_desktop.webp`,
    zielgruppen: `${NOVA_BASE}/nova_x_zielgruppen_desktop.webp`,
    wizardFuerWen: `${NOVA_BASE}/nova_x_wizard_fuerwen_desktop.webp`,
    wizardFallart: `${NOVA_BASE}/nova_x_wizard_fallart_desktop.webp`,
  },
  mobile: {
    dashboard: `${NOVA_BASE}/nova_b6_dashboard_mobile.webp`,
    schnellstart: `${NOVA_BASE}/nova_b2_schnellstart_mobile.webp`,
    fallart: `${NOVA_BASE}/nova_b2_fallart_mobile.webp`,
    docpicker: `${NOVA_BASE}/nova_b3_docpicker_mobile.webp`,
    doclist: `${NOVA_BASE}/nova_b3_doclist_mobile.webp`,
    bewertung: `${NOVA_BASE}/nova_b4_bewertung_mobile.webp`,
    pro: `${NOVA_BASE}/nova_b6_pro_mobile.webp`,
    // Reserve:
    fuerwen: `${NOVA_BASE}/nova_x_fuerwen_mobile.webp`,
    ust: `${NOVA_BASE}/nova_x_ust_mobile.webp`,
  },
  pdf: {
    file: `${NOVA_BASE}/nova_demo_berechnungsprotokoll.pdf`,
    p1: `${NOVA_BASE}/nova_pdf_p1.webp`,
    p2: `${NOVA_BASE}/nova_pdf_p2.webp`,
    p3: `${NOVA_BASE}/nova_pdf_p3.webp`,
    p4: `${NOVA_BASE}/nova_pdf_p4.webp`,
  },
  video: {
    desktopFlow: `${NOVA_BASE}/nova_flow_desktop.mp4`,
    desktopFlowWebm: `${NOVA_BASE}/nova_flow_desktop.webm`,
    desktopPoster: `${NOVA_BASE}/nova_flow_desktop_poster.webp`,
    mobileFlow: `${NOVA_BASE}/nova_flow_mobile.mp4`,
    mobileFlowWebm: `${NOVA_BASE}/nova_flow_mobile.webm`,
    mobilePoster: `${NOVA_BASE}/nova_flow_mobile_poster.webp`,
  },
};

// Semantic beat mapping for the NovaPilot story (6 compact beats).
export const NOVA_BEAT_ASSETS = {
  // Beat 1 — Problem: Autoimport ist kompliziert
  heroDesktop: { src: NOVA_ASSETS.desktop.hero, alt: "NovaPilot — NoVA sicher berechnen: Hero", w: 1920, h: 1098 },
  fallassistentDesktop: { src: NOVA_ASSETS.desktop.fallassistent, alt: "NovaPilot — Kein einfacher Online-Rechner, ein Fallassistent", w: 1920, h: 1098 },
  // Beat 2 — Gefuehrter Fall-Assistent (Schnellstart + Wizard)
  dashboardDesktop: { src: NOVA_ASSETS.desktop.dashboard, alt: "NovaPilot — Dashboard mit Schnellstart-Faellen", w: 1920, h: 1098 },
  wizardDesktop: { src: NOVA_ASSETS.desktop.wizard, alt: "NovaPilot — 6-Step Wizard: Fahrzeugdaten", w: 1920, h: 1098 },
  fallartMobile: { src: NOVA_ASSETS.mobile.fallart, alt: "NovaPilot Mobile — Fallart waehlen", w: 880, h: 1791 },
  schnellstartMobile: { src: NOVA_ASSETS.mobile.schnellstart, alt: "NovaPilot Mobile — Schnellstart-Faelle", w: 880, h: 1791 },
  // Beat 3 — Dokumente & OCR
  uploadDesktop: { src: NOVA_ASSETS.desktop.upload, alt: "NovaPilot — Dokument hochladen", w: 1920, h: 1098 },
  docpickerMobile: { src: NOVA_ASSETS.mobile.docpicker, alt: "NovaPilot Mobile — Dokument auswaehlen: Foto, Galerie, PDF", w: 880, h: 1791 },
  doclistMobile: { src: NOVA_ASSETS.mobile.doclist, alt: "NovaPilot Mobile — Dokumentenliste mit OCR-Status", w: 880, h: 1791 },
  // Beat 4 — Rule Engine & Rechtslagenlogik
  // (Rechtsgrundlagen-Screen: Regelversionen PKW M1 mit Gültigkeitszeitraum, Formel, Max-Satz, Abzug)
  rechtslagenDesktop: { src: NOVA_ASSETS.desktop.historie, alt: "NovaPilot — Rechtsgrundlagen: historische Regelversionen mit Gültigkeitszeitraum (PKW M1)", w: 1920, h: 1098 },
  // Beat 4b — USt- & Preislogik
  ustDesktop: { src: NOVA_ASSETS.desktop.ust, alt: "NovaPilot — USt-Logik im Wizard", w: 1920, h: 1098 },
  bewertungDesktop: { src: NOVA_ASSETS.desktop.bewertung, alt: "NovaPilot — Bewertung und Bemessungsgrundlage", w: 1920, h: 1098 },
  bewertungMobile: { src: NOVA_ASSETS.mobile.bewertung, alt: "NovaPilot Mobile — Bewertungswert und Quelle", w: 880, h: 1791 },
  // Beat 5 — Ergebnis, Risikoampel & PDF-Protokoll (real demo PDF pages)
  pdfPages: [
    { src: NOVA_ASSETS.pdf.p1, alt: "NovaPilot Berechnungsprotokoll — Seite 1: Berechnung auf einen Blick", w: 1200, h: 1698 },
    { src: NOVA_ASSETS.pdf.p2, alt: "NovaPilot Berechnungsprotokoll — Seite 2: Rechtslage und Rechenweg", w: 1200, h: 1698 },
    { src: NOVA_ASSETS.pdf.p3, alt: "NovaPilot Berechnungsprotokoll — Seite 3: Bewertung und Risiko", w: 1200, h: 1698 },
    { src: NOVA_ASSETS.pdf.p4, alt: "NovaPilot Berechnungsprotokoll — Seite 4: Quellen und Disclaimer", w: 1200, h: 1698 },
  ],
  pdfFile: NOVA_ASSETS.pdf.file,
  // Pinned Wizard-Sequenz (Phase 12) — 5 belegte Wizard-Schritte (real screens only;
  // der Bestätigungs-Schritt existiert im Produkt, hat aber keinen Screenshot → nur Text)
  wizardSeq: [
    { src: NOVA_ASSETS.desktop.wizardFuerWen, alt: "NovaPilot Wizard — Schritt: Für wen wird gerechnet?", w: 1920, h: 1098 },
    { src: NOVA_ASSETS.desktop.wizardFallart, alt: "NovaPilot Wizard — Schritt: Fallart wählen", w: 1920, h: 1098 },
    { src: NOVA_ASSETS.desktop.wizard, alt: "NovaPilot Wizard — Schritt: Fahrzeugdaten", w: 1920, h: 1098 },
    { src: NOVA_ASSETS.desktop.ust, alt: "NovaPilot Wizard — Schritt: USt-Logik", w: 1920, h: 1098 },
    { src: NOVA_ASSETS.desktop.bewertung, alt: "NovaPilot Wizard — Schritt: Bewertung und Bemessungsgrundlage", w: 1920, h: 1098 },
  ],
  // Beat 6 — Lead-Funnel / Pro-Modell / Mobile-first
  proDesktop: { src: NOVA_ASSETS.desktop.pro, alt: "NovaPilot — Pro-Modell: Ein Paket, alles drin", w: 1920, h: 1098 },
  proMobile: { src: NOVA_ASSETS.mobile.pro, alt: "NovaPilot Mobile — NoVA Pilot Pro aktivieren", w: 880, h: 1791 },
  dashboardMobile: { src: NOVA_ASSETS.mobile.dashboard, alt: "NovaPilot Mobile — Dashboard: Servus, Josip", w: 880, h: 1791 },
  // Live Flow (Videos)
  flowDesktop: { src: NOVA_ASSETS.video.desktopFlow, webm: NOVA_ASSETS.video.desktopFlowWebm, poster: NOVA_ASSETS.video.desktopPoster, alt: "NovaPilot — Desktop Flow", w: 1280, h: 762 },
  flowMobile: { src: NOVA_ASSETS.video.mobileFlow, webm: NOVA_ASSETS.video.mobileFlowWebm, poster: NOVA_ASSETS.video.mobilePoster, alt: "NovaPilot — Mobile Flow", w: 720, h: 1466 },
};

// ============================================================
// UNFALLHELD — central asset mapping (all REAL client assets).
// Positioning: Digitaler Unfallassistent mit KI-Schadenaufnahme —
// gefuehrte Unfallmeldung, Voice-to-Text, Foto-Upload, Zulassungsschein-OCR,
// unverbindliche KI-Ersteinschaetzung, PDF-Schadensbericht, Betreiber-Dashboard.
// A workflow product — NOT "eine Werkstatt-Website".
// Legal: kein Gutachten, keine verbindlichen Reparaturkosten, keine Deckungszusage.
// PDF pages are rendered from the REAL demo Schadensbericht.
// To replace an asset later: change ONLY the path here.
// ============================================================
const UH_BASE = "/assets/unfallheld";

export const UH_ASSETS = {
  desktop: {
    hero: `${UH_BASE}/uh_b1_hero_desktop.webp`,
    vergleich: `${UH_BASE}/uh_b1_vergleich_desktop.webp`,
    kontakt: `${UH_BASE}/uh_b2_kontakt_desktop.webp`,
    voice: `${UH_BASE}/uh_b3_voice_desktop.webp`,
    fotos: `${UH_BASE}/uh_b4_fotos_desktop.webp`,
    gegner: `${UH_BASE}/uh_b4_gegner_desktop.webp`,
    fahrzeug: `${UH_BASE}/uh_b5_fahrzeug_desktop.webp`,
    unfallort: `${UH_BASE}/uh_x_unfallort_desktop.webp`,
    senden: `${UH_BASE}/uh_x_senden_desktop.webp`,
    status: `${UH_BASE}/uh_b6_status_desktop.webp`,
    dashboard: `${UH_BASE}/uh_b7_dashboard_desktop.webp`,
    falldetail: `${UH_BASE}/uh_b7_falldetail_desktop.webp`,
    // Reserve (delivered, currently unused in layout):
    leistungen: `${UH_BASE}/uh_x_leistungen_desktop.webp`,
    serviceversprechen: `${UH_BASE}/uh_x_serviceversprechen_desktop.webp`,
    statusFotos: `${UH_BASE}/uh_x_status_fotos_desktop.webp`,
    abschluss: `${UH_BASE}/uh_x_abschluss_desktop.webp`,
    faelle: `${UH_BASE}/uh_x_faelle_desktop.webp`,
    timelineAdmin: `${UH_BASE}/uh_x_timeline_admin_desktop.webp`,
    fallUebersicht: `${UH_BASE}/uh_x_fall_uebersicht_desktop.webp`,
  },
  mobile: {
    schritt1: `${UH_BASE}/uh_b2_schritt1_mobile.webp`,
    senden: `${UH_BASE}/uh_b2_senden_mobile.webp`,
    transkript: `${UH_BASE}/uh_b3_transkript_mobile.webp`,
    fotos: `${UH_BASE}/uh_b4_fotos_mobile.webp`,
    ocr: `${UH_BASE}/uh_b5_ocr_mobile.webp`,
    fallnummer: `${UH_BASE}/uh_b6_fallnummer_mobile.webp`,
    timeline: `${UH_BASE}/uh_b6_timeline_mobile.webp`,
    ki: `${UH_BASE}/uh_b6_ki_mobile.webp`,
    dashboard: `${UH_BASE}/uh_b7_dashboard_mobile.webp`,
    briefing: `${UH_BASE}/uh_b7_briefing_mobile.webp`,
    kontakt: `${UH_BASE}/uh_b7_kontakt_mobile.webp`,
    // Reserve:
    fotosCheckliste: `${UH_BASE}/uh_x_fotos_checkliste_mobile.webp`,
    faelle: `${UH_BASE}/uh_x_faelle_mobile.webp`,
    checklisteTimeline: `${UH_BASE}/uh_x_checkliste_timeline_mobile.webp`,
    dokumente: `${UH_BASE}/uh_x_dokumente_mobile.webp`,
  },
  pdf: {
    file: `${UH_BASE}/uh_demo_schadensbericht.pdf`,
    p1: `${UH_BASE}/uh_pdf_p1.webp`,
    p2: `${UH_BASE}/uh_pdf_p2.webp`,
    p3: `${UH_BASE}/uh_pdf_p3.webp`,
    p4: `${UH_BASE}/uh_pdf_p4.webp`,
    p5: `${UH_BASE}/uh_pdf_p5.webp`,
  },
  video: {
    desktopFlow: `${UH_BASE}/uh_flow_desktop.mp4`,
    desktopFlowWebm: `${UH_BASE}/uh_flow_desktop.webm`,
    desktopPoster: `${UH_BASE}/uh_flow_desktop_poster.webp`,
    mobileFlow: `${UH_BASE}/uh_flow_mobile.mp4`,
    mobileFlowWebm: `${UH_BASE}/uh_flow_mobile.webm`,
    mobilePoster: `${UH_BASE}/uh_flow_mobile_poster.webp`,
  },
};

// Semantic beat mapping for the UnfallHeld story (7 compact beats + flow).
export const UH_BEAT_ASSETS = {
  // Beat 1 — Problem: Schadenmeldungen sind chaotisch
  heroDesktop: { src: UH_ASSETS.desktop.hero, alt: "UnfallHeld — Unfall gehabt? Wir machen die Schadensabwicklung einfach", w: 1920, h: 1142 },
  vergleichDesktop: { src: UH_ASSETS.desktop.vergleich, alt: "UnfallHeld — Vergleich: klassischer Weg vs. digitaler Schadenfall", w: 1920, h: 1142 },
  // Beat 2 — Gefuehrte Unfallmeldung (7 Schritte)
  kontaktDesktop: { src: UH_ASSETS.desktop.kontakt, alt: "UnfallHeld — Unfall melden: Schritt 1, persoenliche Daten", w: 1920, h: 1142 },
  schritt1Mobile: { src: UH_ASSETS.mobile.schritt1, alt: "UnfallHeld Mobile — Schritt 1 von 7: persoenliche Daten", w: 880, h: 1792 },
  sendenMobile: { src: UH_ASSETS.mobile.senden, alt: "UnfallHeld Mobile — Schritt 7 von 7: pruefen und senden", w: 880, h: 1569 },
  // Beat 3 — Sprechen statt tippen (Voice-to-Text + KI-Strukturierung)
  voiceDesktop: { src: UH_ASSETS.desktop.voice, alt: "UnfallHeld — Unfall sprechen statt tippen, mit KI strukturieren", w: 1920, h: 1142 },
  transkriptMobile: { src: UH_ASSETS.mobile.transkript, alt: "UnfallHeld Mobile — erkanntes Transkript und KI-strukturierte Beschreibung", w: 880, h: 1569 },
  // Beat 4 — Fotos, Standort & Unfallgegner
  fotosDesktop: { src: UH_ASSETS.desktop.fotos, alt: "UnfallHeld — Schadenbeschreibung und Foto-Upload", w: 1920, h: 1081 },
  gegnerDesktop: { src: UH_ASSETS.desktop.gegner, alt: "UnfallHeld — Unfallgegner mit KI-Erkennung von Dokumenten", w: 1920, h: 1081 },
  fotosMobile: { src: UH_ASSETS.mobile.fotos, alt: "UnfallHeld Mobile — Unfallfotos und Standort", w: 880, h: 1569 },
  // Beat 5 — Zulassungsschein-OCR & Fahrzeugdaten
  fahrzeugDesktop: { src: UH_ASSETS.desktop.fahrzeug, alt: "UnfallHeld — Fahrzeugdaten mit Zulassungsschein-OCR", w: 1920, h: 1142 },
  ocrMobile: { src: UH_ASSETS.mobile.ocr, alt: "UnfallHeld Mobile — Zulassungsschein scannen, Fahrzeugdaten automatisch", w: 880, h: 1792 },
  // Beat 6 — KI-Ersteinschaetzung & Status-Tracking
  statusDesktop: { src: UH_ASSETS.desktop.status, alt: "UnfallHeld — Status verfolgen: Timeline, Dokumenten-Checkliste, KI-Panel", w: 1920, h: 1081 },
  kiMobile: { src: UH_ASSETS.mobile.ki, alt: "UnfallHeld Mobile — KI-Ersteinschaetzung mit erkannten Schaeden", w: 880, h: 1656 },
  timelineMobile: { src: UH_ASSETS.mobile.timeline, alt: "UnfallHeld Mobile — Status-Timeline des Schadenfalls", w: 880, h: 1656 },
  // Beat 7 — PDF-Schadensbericht (echtes Demo-PDF, 5 Seiten)
  pdfPages: [
    { src: UH_ASSETS.pdf.p1, alt: "UnfallHeld Schadensbericht — Seite 1: Falldaten und KI-Ersteinschaetzung", w: 1200, h: 1698 },
    { src: UH_ASSETS.pdf.p2, alt: "UnfallHeld Schadensbericht — Seite 2: Sprachtranskript und Zusammenfassung", w: 1200, h: 1698 },
    { src: UH_ASSETS.pdf.p3, alt: "UnfallHeld Schadensbericht — Seite 3: festgestellte Schaeden und wichtiger Hinweis", w: 1200, h: 1698 },
    { src: UH_ASSETS.pdf.p4, alt: "UnfallHeld Schadensbericht — Seite 4: Unfallfotos", w: 1200, h: 1698 },
    { src: UH_ASSETS.pdf.p5, alt: "UnfallHeld Schadensbericht — Seite 5: Versicherungszusammenfassung und Disclaimer", w: 1200, h: 1698 },
  ],
  pdfFile: UH_ASSETS.pdf.file,
  // Pinned 7-Schritte-Meldeflow-Sequenz (Phase 12) — alle 7 Schritte als echte Screens
  flowSeq: [
    { src: UH_ASSETS.desktop.kontakt, alt: "UnfallHeld Meldeflow — Schritt 1: persoenliche Daten", w: 1920, h: 1142 },
    { src: UH_ASSETS.desktop.fahrzeug, alt: "UnfallHeld Meldeflow — Schritt 2: Fahrzeug und Zulassungsschein-OCR", w: 1920, h: 1142 },
    { src: UH_ASSETS.desktop.voice, alt: "UnfallHeld Meldeflow — Schritt 3: Unfall einsprechen statt tippen", w: 1920, h: 1142 },
    { src: UH_ASSETS.desktop.fotos, alt: "UnfallHeld Meldeflow — Schritt 4: Schadenfotos hochladen", w: 1920, h: 1081 },
    { src: UH_ASSETS.desktop.unfallort, alt: "UnfallHeld Meldeflow — Schritt 5: Unfallort per GPS", w: 1920, h: 1081 },
    { src: UH_ASSETS.desktop.gegner, alt: "UnfallHeld Meldeflow — Schritt 6: Unfallgegner mit KI-Erkennung", w: 1920, h: 1081 },
    { src: UH_ASSETS.desktop.senden, alt: "UnfallHeld Meldeflow — Schritt 7: pruefen und senden", w: 1920, h: 1081 },
  ],
  // Beat 8 — Betreiber-Dashboard & Leadflow
  dashboardDesktop: { src: UH_ASSETS.desktop.dashboard, alt: "UnfallHeld — Betreiber-Dashboard mit allen Schadenfaellen", w: 1920, h: 1081 },
  falldetailDesktop: { src: UH_ASSETS.desktop.falldetail, alt: "UnfallHeld — Falldetail mit Status und Dokumenten", w: 1920, h: 1081 },
  briefingMobile: { src: UH_ASSETS.mobile.briefing, alt: "UnfallHeld Mobile — 10-Sekunden-Briefing zum Fall", w: 880, h: 1569 },
  kontaktMobile: { src: UH_ASSETS.mobile.kontakt, alt: "UnfallHeld Mobile — Schnellkontakt per Anruf oder WhatsApp", w: 880, h: 1569 },
  dashboardMobile: { src: UH_ASSETS.mobile.dashboard, alt: "UnfallHeld Mobile — Dashboard mit Schadenfaellen", w: 880, h: 1569 },
  // Live Flow (Videos)
  flowDesktop: { src: UH_ASSETS.video.desktopFlow, webm: UH_ASSETS.video.desktopFlowWebm, poster: UH_ASSETS.video.desktopPoster, alt: "UnfallHeld — Desktop Flow", w: 1280, h: 762 },
  flowMobile: { src: UH_ASSETS.video.mobileFlow, webm: UH_ASSETS.video.mobileFlowWebm, poster: UH_ASSETS.video.mobilePoster, alt: "UnfallHeld — Mobile Flow", w: 720, h: 1466 },
};

// 6 real projects. hasAssets=true only for delivered asset sets.
export const PROJECTS = [
  {
    id: "dealalert",
    name: "DealAlert.ai",
    url: "https://dealalert.ai",
    categoryKey: "catAiSaas",
    badges: ["AI Advisor", "iOS App", "Stripe"],
    allBadges: [
      "AI Advisor", "iOS App", "Web App", "Stripe", "Referral",
      "Admin Dashboard", "Data Pipeline", "AutoTech", "PropTech", "Market Engine",
    ],
    hasAssets: true,
    accent: "#00d4ff",
  },
  {
    id: "novapilot",
    name: "NovaPilot.at",
    url: "https://novapilot.at",
    categoryKey: "catB2bSaas",
    badges: ["NoVA Calculator", "Rule Engine", "OCR Documents", "Lead Funnel"],
    allBadges: [
      "NoVA Calculator", "Rule Engine", "Rechtslagen-Logik", "OCR Documents",
      "USt-Logik", "Risikoampel", "PDF-Protokoll", "Lead Funnel", "Pro-Modell", "Mobile First",
    ],
    hasAssets: true,
    accent: "#14b8a6",
  },
  {
    id: "unfallheld",
    name: "UnfallHeld.com",
    url: "https://unfallheld.com",
    categoryKey: "catInsurtech",
    badges: ["KI-Schadenaufnahme", "Photo Upload", "OCR", "Workshop Dashboard"],
    allBadges: [
      "KI-Schadenaufnahme", "Photo Upload", "Voice-to-Text", "OCR",
      "PDF Dossier", "KI-Ersteinschätzung", "Status-Tracking",
      "Workshop Dashboard", "Lead Management", "Mobile First", "Automotive Claims",
    ],
    hasAssets: true,
    accent: "#22d3ee",
  },
  {
    id: "naperformance",
    name: "NAPerformance.at",
    url: "https://naperformance.at",
    categoryKey: "catAutomotiveAi",
    badges: ["AI Performance Advisor", "OCR", "WhatsApp Lead Flow"],
    allBadges: [
      "AI Performance Advisor", "OCR", "Automotive AI", "WhatsApp Lead Flow",
      "Admin CRM", "PWA", "Mobile First", "Lead Automation",
    ],
    hasAssets: true,
    accent: "#dc2626",
  },
  {
    id: "hausdeshandys",
    name: "HausDesHandys.at",
    url: "https://hausdeshandys.at",
    categoryKey: "catRetail",
    badges: ["Repair Configurator", "Smart Pricing", "AI Assistant"],
    allBadges: [
      "Repair Configurator", "Smart Pricing", "AI Assistant", "Admin Dashboard",
      "Mobile First", "RetailTech", "Digital Transformation",
    ],
    hasAssets: true,
    accent: "#ef4444",
  },
  {
    id: "naautomobile",
    name: "NAAutomobile.at",
    url: "https://naautomobile.at",
    categoryKey: "catAutomotive",
    badges: ["AI Photo Studio", "WhatsApp-first", "Financing", "Ankauf-Leads"],
    allBadges: [
      "AI Photo Studio", "View-Lock", "AI Backgrounds", "WhatsApp-first",
      "Vehicle Inventory", "Financing Calculator", "AI Price Estimate",
      "Ankauf-Leads", "Dealer Dashboard", "Sales Automation", "Premium Automotive",
    ],
    hasAssets: true,
    accent: "#e11d48",
  },
];

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
